module.exports = __webpack_public_path__ + "static/vampiric_mist-f85cc5b204bed38e5c6de1b86d15a09c.png";